import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

const CAR_STATUS_COLORS = {
    pending: 'default',
    in_progress: 'processing',
    success: 'success',
    failed: 'error',
    not_found: 'default',
};

/** A car's current status: Failed red, Success green, Not found grey, In progress blue, Pending grey. */
const CarStatusTag = ({ status }) => {
    const { t } = useTranslation('vinExtraction');

    return (
        <Tag color={CAR_STATUS_COLORS[status]} bordered={false}>
            {t(`cars.status.${status}`)}
        </Tag>
    );
};

export default CarStatusTag;
